export default {
      id: "icon-insights-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-insights",
      toString: function () {
        return this.url;
      }
    }